import React from 'react';
import { useGetAllHiringAssessments } from 'src/hooks/hiringAssessment.hooks';
import HiringAssessmentCard from './HiringAssessmentCard';
import { HiringAssessmentListCard } from 'types';
import { Button, Spinner } from 'flowbite-react';
import Container from 'src/components/shared/Container';
import { FaPlus } from 'react-icons/fa6';
import { Img } from 'react-image';
import { useNavigate } from 'react-router-dom';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
import HiringAssessmentEmptyState from '../HiringAssessmentEmptyState';

const HiringAssessmentList = () => {
	const navigate = useNavigate();
	const { data: allHiringAssessments, isLoading } = useGetAllHiringAssessments();

	return (
		<Container className="flex flex-col">
			<div className="py-[16px]">
				<div className="flex justify-between items-center pb-4">
					<p className="text-[#1C1C28] font-inter text-base md:text-xl font-[600]">Assessment based tests</p>
					{allHiringAssessments?.hiringAssessmentList?.length ? (
						<Button
							size="sm"
							className="whitespace-pre"
							color="purplePlaced"
							onClick={() => {
								navigate('/benchmarking/create-hiring-assessment');
							}}
						>
							<FaPlus className="mr-2" />
							New Assessment
						</Button>
					) : null}
				</div>
				<hr className="bg-[#E4E4EB]" />
			</div>
			{isLoading ? (
				<div className="flex-1 flex items-center justify-center h-full w-full">
					{/* <Spinner /> */}
					<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
				</div>
			) : allHiringAssessments?.hiringAssessmentList?.length ? (
				<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-[24px] items-center justify-center pb-4">
					{allHiringAssessments?.hiringAssessmentList?.map((hiringAssessment: HiringAssessmentListCard) => (
						<HiringAssessmentCard key={hiringAssessment?._id} hiringAssessmentListCard={hiringAssessment} />
					))}
				</div>
			) : (
				<div className="flex flex-1 flex-col items-center">
					<HiringAssessmentEmptyState />
				</div>
			)}
		</Container>
	);
};

export default HiringAssessmentList;
